import PropTypes from "prop-types";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const styles = {
  icon: { width: "25px" },
  icon1: { cursor: "pointer", width: "25px" },
  icon2: { cursor: "not-allowed", width: "25px" },
};

export default function ProcessDoneIcon(props) {
  const done = props.done || false;
  const disabled = props.disabled || false;
  const hasClickEvent = props.onClick !== undefined && !disabled;

  const handleKlik = () => {
    props.onClick();
  };

  if (!done)
    return (
      <CheckBoxOutlineBlankIcon style={styles.icon1} onClick={handleKlik} aria-label="Valmis" />
    );
  else {
    return (
      <CheckBoxIcon
        color="success"
        style={hasClickEvent ? styles.icon1 : styles.icon2}
        onClick={handleKlik}
        aria-label="Valmis"
      />
    );
  }
}

ProcessDoneIcon.propTypes = {
  done: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
